import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosCentral, throwResponse } from "config/axios";
import { ITaskStatus } from "./interface";
import {
  IDashboardGraph,
  IDashboardParams,
  IDashboardTitle,
  IResponseDashboardCentral,
} from "../../interface";

export const useGetDashboardTask = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<ITaskStatus>[], Error> => {
  return useQuery(
    ["dashboard-task", "work-detail"],
    async () => {
      const res = await axiosCentral.get("/dashboard/task/work-detail", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      keepPreviousData: true,
    }
  );
};

export const useGetDashboardTaskCategory = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IDashboardTitle[]>[], Error> => {
  return useQuery(
    ["dashboard-task", "graph-by-category", params],
    async () => {
      const res = await axiosCentral.get("/dashboard/task/graph-by-category", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      keepPreviousData: true,
    }
  );
};

export const useGetDashboardTaskProgress = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IDashboardGraph[]>[], Error> => {
  return useQuery(
    ["dashboard-task", "graph-progress-monthly", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/task/graph-progress-monthly",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      keepPreviousData: true,
    }
  );
};
